import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle, ArrowRight, ClipboardList, Mail } from 'lucide-react';
import SeoHead from '../components/SeoHead';

const ThankYouPage = () => {
  const location = useLocation();
  const qualificationLink = location.state?.qualificationLink;
  const candidateName = location.state?.candidateName || '';

  return (
    <div className="min-h-screen flex flex-col bg-tp-bg">
      <SeoHead
        pageTitle="Candidature envoyée — Talent Partner"
        pageDescription="Votre candidature a été reçue. Merci de votre intérêt pour Talent Partner."
        noindex={true}
      />
      <nav className="bg-white border-b border-tp-border">
        <div className="max-w-3xl mx-auto px-4 py-4 text-center">
          <span className="text-lg font-display font-semibold text-tp-primary">Talent Partner</span>
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <Card className="max-w-lg w-full p-6 sm:p-10 text-center border-tp-border" data-testid="thank-you-card">
          <div className="w-16 h-16 bg-[#4C8F6E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-8 w-8 text-[#4C8F6E]" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-display font-semibold text-tp-text mb-3">
            Merci{candidateName ? ` ${candidateName}` : ''} !
          </h1>

          <p className="text-tp-text-light mb-8">
            Votre candidature a bien été envoyée. Notre équipe va analyser votre profil.
          </p>

          {qualificationLink && (
            <div className="bg-[#0F2744] text-white rounded-xl p-6 mb-8 text-left" data-testid="qualification-cta">
              <div className="flex items-start gap-3 mb-4">
                <ClipboardList className="h-6 w-6 text-[#4C8F6E] flex-shrink-0 mt-0.5" />
                <div>
                  <h2 className="font-semibold text-lg mb-1">Complétez votre évaluation</h2>
                  <p className="text-white/70 text-sm">
                    Pour accélérer le traitement de votre dossier, complétez dès maintenant ce court formulaire (10-15 min).
                  </p>
                </div>
              </div>
              <a href={qualificationLink} className="block">
                <Button className="w-full bg-[#4C8F6E] hover:bg-[#3d7a5c] text-white h-12 text-base" data-testid="start-evaluation-btn">
                  Commencer l'évaluation <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </a>
            </div>
          )}

          <div className="space-y-4 text-left">
            <h3 className="font-semibold text-tp-text text-sm">Prochaines étapes :</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#4C8F6E]/10 text-[#4C8F6E] text-xs font-bold flex items-center justify-center">1</span>
                <p className="text-sm text-tp-text-light">Analyse de votre CV par notre équipe</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#4C8F6E]/10 text-[#4C8F6E] text-xs font-bold flex items-center justify-center">2</span>
                <p className="text-sm text-tp-text-light">Complétez le formulaire d'évaluation{qualificationLink ? ' (lien ci-dessus)' : ' (lien envoyé par email)'}</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#4C8F6E]/10 text-[#4C8F6E] text-xs font-bold flex items-center justify-center">3</span>
                <p className="text-sm text-tp-text-light">Entretien vidéo si votre profil correspond</p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-tp-border flex items-center justify-center gap-2 text-sm text-tp-text-light">
            <Mail className="h-4 w-4" />
            <span>Un email de confirmation a été envoyé</span>
          </div>

          <Link to="/" className="block mt-6">
            <Button variant="outline" className="border-tp-border text-tp-text-light">
              Retour à l'accueil
            </Button>
          </Link>
        </Card>
      </div>
    </div>
  );
};

export default ThankYouPage;
